import React, { useState } from 'react';
import { FaBolt } from 'react-icons/fa';
import { arenaAPI } from '../../utils/api';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const CATEGORIES = ['open', 'tech', 'sports', 'culture', 'politics', 'entertainment', 'science'];

const ChallengeForm = ({ opponent, onClose }) => {
  const [topic, setTopic] = useState('');
  const [category, setCategory] = useState('open');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const currentUser = JSON.parse(sessionStorage.getItem('user') || '{}');

  const handleChallenge = async () => {
    if (!topic.trim()) return toast.error('Enter a debate topic');
    setSubmitting(true);
    try {
      await arenaAPI.createDebate({ topic, category, opponent_id: opponent.id });
      toast.success(`Challenge sent to @${opponent.username}!`);
      onClose();
      navigate('/arena');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to send challenge');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="p-6">
        <div className="flex items-center space-x-3 mb-5">
          <div className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center"><FaBolt className="text-white" size={14} /></div>
          <div>
            <h2 className="text-lg font-bold text-gray-900" data-testid="challenge-modal-title">Challenge @{opponent.username}</h2>
            <p className="text-xs text-gray-400">Send a debate challenge to the <span className="font-arthaus">PointArena</span></p>
          </div>
        </div>
        <div className="flex items-center justify-center space-x-6 mb-5 py-3 bg-gray-50 rounded-xl">
          <div className="text-center">
            <img src={currentUser.avatar_url || 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg'} alt="You" className="w-12 h-12 rounded-full object-cover ring-2 ring-gray-200 mx-auto" />
            <p className="text-xs font-semibold text-gray-700 mt-1">You</p>
          </div>
          <div className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center"><span className="text-white font-extrabold text-xs">VS</span></div>
          <div className="text-center">
            <img src={opponent.avatar_url || `https://ui-avatars.com/api/?name=${opponent.full_name}&size=48`} alt={opponent.full_name} className="w-12 h-12 rounded-full object-cover ring-2 ring-gray-200 mx-auto" />
            <p className="text-xs font-semibold text-gray-700 mt-1 truncate max-w-[80px]">@{opponent.username}</p>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider block mb-1.5">Debate Topic</label>
            <input type="text" value={topic} onChange={e => setTopic(e.target.value)} placeholder="e.g., Tabs vs Spaces?" className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-gray-200" data-testid="challenge-topic-input" />
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider block mb-1.5">Category</label>
            <div className="flex flex-wrap gap-2">
              {CATEGORIES.map(cat => (
                <button key={cat} onClick={() => setCategory(cat)} data-testid={`challenge-category-${cat}`} className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all capitalize ${category === cat ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}>{cat}</button>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="flex space-x-3 p-4 border-t border-gray-100">
        <button onClick={onClose} className="flex-1 py-2.5 rounded-xl text-sm font-medium text-gray-500 hover:bg-gray-50 transition-colors" data-testid="cancel-challenge-btn">Cancel</button>
        <button onClick={handleChallenge} disabled={submitting} data-testid="send-challenge-btn" className="flex-1 py-2.5 rounded-xl text-sm font-semibold bg-gray-900 text-white hover:bg-gray-800 transition-colors disabled:opacity-50 flex items-center justify-center space-x-2">
          <FaBolt size={12} /><span>{submitting ? 'Sending...' : 'Send Challenge'}</span>
        </button>
      </div>
    </>
  );
};

export default ChallengeForm;
